import type { FaireProductEntity } from "../../entity_types/product";

export const p_64nqxsg2gs: FaireProductEntity = {
  token: "p_64nqxsg2gs",
  type: "product",
  name: "Leopard print pocket leggings, womans pants",
  brandToken: "b_na6tfqypxs",
  brandName: "Triple Goddess Boutique",
  imageUrl:
    "https://cdn.faire.com/fastly/b739c9f3b142b32e767ef57b2432e7bec8abf98d6698bd1ef8c88bf549a7e0c0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/20f77583c2520b9c343529a0da862f6c79dd19d5d2517fed7d1e3372b12a451b.jpeg",
    "https://cdn.faire.com/fastly/0036438119a0023b9f0b243a98199e5b300279112745bf96100b9edc9f98dff4.jpeg",
    "https://cdn.faire.com/fastly/804fb088aff73cf483c323dbba5e73c0f079278cc7324599d075d4177740760d.jpeg",
    "https://cdn.faire.com/fastly/586edd122d8af82fc678b414a4a4266aabb9e218140a37f0cca09ee92806ed05.jpeg",
    "https://cdn.faire.com/fastly/58539036f3f1edff0fcb86a0582aa17a2552585bd604ac32f304073e5bc0d711.jpeg",
    "https://cdn.faire.com/fastly/182d9761afa7ee90e4a75dceda2d49563bc97392477f9883fd8af00d0085b206.jpeg",
  ],
  priceDollars: 20.79,
  description:
    "Designed to meet your everyday needs Triple Goddess Boutique’s exclusive collection can’t be found anywhere else. With two fully functional pockets designed to fit even the largest phones. 3” wide comfort waistband and custom fit to accommodate your unique body shape. The unique fabric blend will stretch to fit whether you are short or tall! Buttery Soft material perfect for all day wear. Always Opaque.\nHand wash or delicate cycle cold, hang dry\n\n\nOS fits 2-12\n\nTC fits 12-18\n\nTC2 fits 18-28\n\n92% Polyester, 8% Spandex",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:39.547Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
